export const arraysAreEqual = (array1, array2) => {

    let istheSame = false

    if (JSON.stringify(array1) === JSON.stringify(array2)) {
        istheSame = true
    }

    return istheSame
}